export const SHAPES = [
  { value: 'round', label: 'Tròn', name: 'Round' },
  { value: 'cushion', label: 'Đệm', name: 'Cushion' },
  { value: 'emerald', label: 'Chữ nhật', name: 'Emerald' },
  { value: 'oval', label: 'Oval', name: 'Oval' },
  { value: 'princess', label: 'Vuông', name: 'Princess' },
  { value: 'pear', label: 'Giọt lệ', name: 'Pear' },
  { value: 'radiant', label: 'Radiant', name: 'Radiant' },
  { value: 'marquise', label: 'Hạt thóc', name: 'Marquise' },
  { value: 'asscher', label: 'Asscher', name: 'Asscher' },
  { value: 'heart', label: 'Trái tim', name: 'Heart' },
] as const;

export const COLORS = ['K', 'J', 'I', 'H', 'G', 'F', 'E', 'D'] as const;
export const CLARITIES = ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL'] as const;
export const GRADES = [
  { value: 'fair', label: 'Fair' },
  { value: 'good', label: 'Good' },
  { value: 'very-good', label: 'Very Good' },
  { value: 'excellent', label: 'Excellent' },
] as const;
export const FLUORESCENCE = [
  { value: 'very-strong', label: 'Rất mạnh' },
  { value: 'strong', label: 'Mạnh' },
  { value: 'medium', label: 'Trung bình' },
  { value: 'faint', label: 'Nhẹ' },
  { value: 'none', label: 'Không' },
] as const;

export type DiamondInput = {
  shape: typeof SHAPES[number]['value'];
  carat: number;
  color: typeof COLORS[number];
  clarity: typeof CLARITIES[number];
  cut: typeof GRADES[number]['value'];
  symmetry: typeof GRADES[number]['value'];
  polish: typeof GRADES[number]['value'];
  fluorescence: typeof FLUORESCENCE[number]['value'];
};

export const DEFAULT_DIAMOND_INPUT: DiamondInput = {
  shape: 'round', carat: 1, color: 'G', clarity: 'VS2',
  cut: 'excellent', symmetry: 'excellent', polish: 'excellent', fluorescence: 'none',
};

/** Public calculator links emitted by StoneAlgo's own input controls. */
export const buildDiamondSourceUrl = (input: DiamondInput): string => {
  const grades = GRADES.map(({ value }) => value);
  const params = new URLSearchParams({
    a: String(SHAPES.findIndex(({ value }) => value === input.shape) + 1),
    b: String(input.carat),
    c: String(COLORS.indexOf(input.color) + 1),
    d: String(CLARITIES.indexOf(input.clarity) + 1),
    e: String(grades.indexOf(input.cut) + 1),
    f: String(grades.indexOf(input.symmetry) + 1),
    g: String(grades.indexOf(input.polish) + 1),
    h: String(FLUORESCENCE.findIndex(({ value }) => value === input.fluorescence) + 1),
    i: '0',
  });
  return `https://www.stonealgo.com/diamond-price-calculator/calc?${params}`;
};
